import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Loader2, Check, Sparkles } from "lucide-react";
import { api } from "@/lib/api";

export default function SubscriptionSuccessPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let cancelled = false;

    const tick = async () => {
      try {
        const { data } = await api.get(`/subscriptions/status/${sessionId}`);
        if (cancelled) return;
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired" || data.status === "failed") { setStatus("failed"); return; }
        setAttempts((n) => n + 1);
        if (attempts < 12) setTimeout(tick, 2000);
        else setStatus("timeout");
      } catch {
        if (!cancelled) setStatus("error");
      }
    };
    tick();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  return (
    <main className="min-h-[70vh] flex items-center justify-center py-16" data-testid="subscription-success">
      <div className="max-w-xl w-full px-6 text-center">
        {status === "polling" && (
          <>
            <Loader2 size={40} className="animate-spin mv-green-text mx-auto" />
            <div className="mt-6 font-display text-2xl mv-green-text">Confirming your subscription…</div>
            <p className="mt-2 text-[14px]" style={{ color: "var(--mv-muted)" }}>One moment while Stripe confirms your payment.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <div className="w-16 h-16 rounded-full flex items-center justify-center mv-green-bg text-white mx-auto">
              <Check size={28}/>
            </div>
            <div className="mt-6 inline-flex items-center gap-2 rounded-full px-3.5 py-1.5" style={{ background: "rgba(212,175,55,0.14)" }}>
              <Sparkles size={13} style={{ color: "var(--mv-gold)" }} />
              <span className="text-[11px] uppercase tracking-[0.24em] font-semibold mv-green-text">Founding Member</span>
            </div>
            <h1 className="mt-4 font-display text-3xl md:text-4xl mv-green-text leading-tight">
              Welcome to the founding circle. 💧
            </h1>
            <p className="mt-4 text-[14.5px]" style={{ color: "var(--mv-ink)" }}>
              Your support means we can keep the doors open a little wider, for a little longer, until the first project completes. I'll write to you personally within 48 hours.
            </p>
            <div className="mt-8 flex flex-wrap gap-3 justify-center">
              <Link to="/" className="btn-gold" data-testid="ss-home">Back to Home</Link>
              <Link to="/waiting-list" className="btn-ghost" data-testid="ss-waitlist">Join the Waiting List</Link>
            </div>
          </>
        )}
        {(status === "failed" || status === "timeout" || status === "error") && (
          <>
            <div className="font-display text-2xl" style={{ color: "#8a2020" }}>Something didn't complete.</div>
            <p className="mt-2 text-[14px]" style={{ color: "var(--mv-muted)" }}>
              No charge has been finalised on our end. If your card was charged in error, email Sebata@pulalove.com and we'll refund immediately.
            </p>
            <div className="mt-6"><Link to="/" className="btn-green">Back to Home</Link></div>
          </>
        )}
      </div>
    </main>
  );
}
